import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import style1 from '../../../scss/components/Applications/ApplicationCategoryList';
import ApplicationCategoryCard from './ApplicationCategoryCard';
import { Transition } from 'semantic-ui-react'
import style from '../../../scss/components/Applications/ApplicationCategorySelector';
import 'semantic-ui-css/components/transition.min.css';
import ImageBlock from '../ImageBlock';
import ApplicationCategorySelector from './ApplicationCategorySelector';
export default class ApplicationCategoryView extends React.Component {
    static propTypes = {
        category: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            subcategories: PropTypes.array,
            applications: PropTypes.number
        }),
        onViewDetail: PropTypes.func
    }
    constructor(props) {
        super(props);
        this.state = {
            category: ""
        };
    }
    getCategoriesForDropdown = () => {
        const categoryOptions = [];
        this.props.allCategories.map((data, index) => {
            categoryOptions.push({
                key: data.name,
                text: <span><i className="chooser-icon"><ImageBlock image={data.icon} addWrapper={false} /></i>{data.name}</span>,
                value: data.name
            })
        })
        return categoryOptions;
    }
    getGoToParentLink = () => {
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        if (parentPage) {
            var [url, title] = parentPage.split(';');
            return <section>
                <div className="container"><a href={url} className="btn btn-link-normal btn-back-link">
                    <i className="icon icon-prev"></i>{title}
                </a></div>
            </section>
        }
        return null;
    }
    handleChange = (e, { value }) => this.setState({ category: value })
    handleGoClick = () => {
        window.location.href = window.location.href + this.state.category;
    }
    getCategoryCardList = (categoryList) => {
        var self = this;
        if (categoryList && categoryList.length > 0) {
            return categoryList.map(function (objCategory, index) {
                return (<li key={index} className="product-item application-items products-page-card">
                    <ApplicationCategoryCard category={objCategory} parentCategory={self.props.category} onViewDetail={self.props.onViewDetail}></ApplicationCategoryCard>
                </li>);
            });
        }
        else
            return null;
    }
    getGoToParentCategoryLink = () => {
        if (!this.props.category.parent)
            return null;
        return  <div className="breadcrumbs">
            <a className="btn btn-link-normal breadcrumbs-link" onClick={() => { this.props.onViewDetail(this.props.category.parent) }}>
                <i className="icon icon-prev"></i> All {this.props.category.parent.name}
            </a>
        </div>
    }
    render() {
        if (this.props.category == null)
            return null;
        return (
            <>
                <ApplicationCategorySelector {...this.props} isCompactMode={true} selectedCategory={this.props.selectedCategory}></ApplicationCategorySelector>
                <div className="product-list-section application-list-section">
                    <div className="container">
                        {this.getGoToParentCategoryLink()}
                        <Transition visible={this.props.visible} animation='fade' duration={300}>
                            <div className="product-list" >
                                <div className="product-info" >
                                    <h1 className="product-info-title">{this.props.category.name}</h1>
                                    <p className="appcategory-text-content">{this.props.category.description}</p>
                                </div>
                                <div className='application-div'>
                                    <ul className="application-items">
                                        {this.getCategoryCardList(this.props.category.subcategories)}
                                    </ul>
                                </div>
                            </div>
                        </Transition>
                    </div>
                </div>
            </>
        )
    }
}
